export default function About() {
  return (
    <section id="about" className="section-padding bg-surface-container-low/30">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center font-headline">
          About <span className="text-primary">Me</span>
        </h2>
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <p className="text-on-surface-variant leading-relaxed">
              I'm a <strong className="text-white">M.Sc. Computational Linguistics</strong> student at <strong className="text-white">Universität Stuttgart</strong>, passionate about bridging the gap between complex AI models and real-world applications.
            </p>
            <p className="text-on-surface-variant leading-relaxed">
              My expertise spans from <strong className="text-primary">speech synthesis</strong> and <strong className="text-primary">NLP</strong> to building <strong className="text-primary">automated AI agents</strong> that solve real business problems. I specialize in rapid prototyping and solutions architecture.
            </p>
            <p className="text-on-surface-variant leading-relaxed">
              Whether it's building robust deepfake detection benchmarks, creating AI-powered browser extensions, or orchestrating multi-agent systems for job automation - I love turning complex requirements into elegant, working solutions.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="p-6 bg-surface-container-low rounded-xl border-l-4 border-primary">
              <h3 className="text-3xl font-bold text-primary mb-2 font-headline">6+</h3>
              <p className="text-sm text-on-surface-variant">Projects Completed</p>
            </div>
            <div className="p-6 bg-surface-container-low rounded-xl border-l-4 border-primary">
              <h3 className="text-3xl font-bold text-primary mb-2 font-headline">3+</h3>
              <p className="text-sm text-on-surface-variant">Technologies</p>
            </div>
            <div className="p-6 bg-surface-container-low rounded-xl border-l-4 border-secondary">
              <h3 className="text-3xl font-bold text-secondary mb-2 font-headline">M.Sc.</h3>
              <p className="text-sm text-on-surface-variant">Comp. Linguistics</p>
            </div>
            <div className="p-6 bg-surface-container-low rounded-xl border-l-4 border-primary">
              <h3 className="text-3xl font-bold text-primary mb-2 font-headline">4</h3>
              <p className="text-sm text-on-surface-variant">Languages</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
